export const URLS = {
    // auth
    USER: "/api/account/user/",
    GROUP: "/api/account/group/",
    MENU: "/api/account/menu/",
    MODULE: "/api/account/module/",
    MODULE_MENU: "/api/account/module_menu/",
    TOKEN: "/api/account/token/",
    CONTENT_TYPE: "/api/account/content_type/",
    PERMISSION: "/api/account/permission/",

    //registration
    STATION: "/api/pplan/station/",
    SEGMENT: "/api/pplan/segment/",
    CATEGORY: "/api/general/category/",
    PROJECT: "/api/general/project/",
    CLIENT: "/api/general/client/",
    LOB: "/api/general/lob/",
    FT_BOM_GROUP: "/api/general/ft_bom_group/",
    PO_MONITORING: "/api/purchase-order/purchase_order/",
    PO_ASSOCIATE_W_PROJECTS: "/api/purchase-order/purchase_order/:id/associate-with-projects/",
    PO_MONITORING_MATERIAL: "/api/purchase-order/purchase_order/:id/list-materials/",
    PO_MONITORING_DASHBOARD: "/api/purchase-order/purchase_order/dashboard",
    PO_MONITORING_SHIPMENT: "/api/purchase-order/purchase_order_items/:id/list_shipments/",

    IMPORT_PO: "/api/purchase-order/import_purchase_order/",
    IMPORT_PO_LIST_YEARS: "/api/purchase-order/import_purchase_order/list_years/",
    IMPORT_AMORTIZATION: "/api/purchase-order/import_amortization/",
    IMPORT_AMORTIZATION_CLIENT: "/api/purchase-order/import_amortization/list_clients/",
    IMPORT_AMORTIZATION_DOWNLOAD: "/api/purchase-order/import_amortization/:id/download/",
    IMPORT_RELATED_COST: "/api/purchase-order/import_related_cost/",
    IMPORT_RELATED_COST_LIST_YEARS: "/api/purchase-order/import_related_cost/list_years/",
    IMPORT_INTEGRATION_ROUTINES: "/api/purchase-order/rfc_execucao_manual/",

    REPORT_ASSET_CONTROL: "/api/purchase-order/project_summary/",
    REPORT_ASSET_CONTROL_PROJECT: "/api/purchase-order/project_summary/list_projects/",
    REPORT_ASSET_CONTROL_PROJECT_XLSX: "/api/purchase-order/project_summary/export_xlsx/",
    REPORT_INVOICE_BY_ID_PROJECT: "/api/purchase-order/invoice/list_invoices",
    REPORT_RELATED_COST: "/api/purchase-order/related_cost/",
    REPORT_RELATED_COST_LIST_YEARS: "/api/purchase-order/related_cost/list_years/",
    REPORT_COST_ALLOCATION: "/api/purchase-order/cost_allocation/",
    REPORT_FT_BOM: "/api/purchase-order/ftbom/",
    DASHBOARD: "/api/purchase-order/dashboard/",
    REPLENISHMENT_SETTING: "/api/purchase-order/replenishment_setting/",
    REPLANISHMENT_SPARE_PARTS: "/api/purchase-order/replenishment_spare_parts/",
    PENDING_NRE_INVOICE: "/api/purchase-order/invoice_pending",

    SCHEDULED_STOP: "/api/pplan/scheduled_stop/",
    MARKER: "/api/pplan/marker/",
    REASON_REPLANNING: "/api/pplan/reason_replanning/",
    CALENDAR_EVENT_TYPE: "/api/pplan/calendar_event_type/",
    CALENDAR_EVENT: "/api/pplan/calendar_event/",
    PRODUCTION_LINE: "/api/pplan/production_line/",
    PRODUCTION_LINE_STATION: "/api/pplan/production_line_station/",
    PRODUCT: "/api/pplan/product/",
    SIDE: "/api/pplan/side/",
    SHIFT: "/api/pplan/shift/",
    SCHEDULED_STOP_SHIFT: "/api/pplan/scheduled_stop_shift/",
    PRODUCTION_RAMP: "/api/pplan/production_ramp/",
    PRODUCTION_RAMP_SHIFT: "/api/pplan/production_ramp_shift/",
    ALERT: "/api/pplan/alert/",
    DOWNTIME_REASON: "/api/pplan/downtime_reason/",
    DOWNTIME: "/api/pplan/downtime/",
    DOWNTIME_REPORT_DATA: "/api/pplan/downtime_report_data/",
    OEE: "/api/pplan/oee/",
    OEE_MONTH_GOAL: "/api/pplan/oee_month_goal/",
    OEE_YEAR_GOAL: "/api/pplan/oee_year_goal/",
    ACTIVE_LINE_COUNT: "/api/pplan/active_line_count/",
    ACTIVE_LINE_SHIFT: "/api/pplan/active_line_shift/",
    ACTIVE_PEOPLE_COUNT: "/api/pplan/active_people_count/",
    ACTIVE_PEOPLE_LINE: "/api/pplan/active_people_line/",

    //planning
    DEMAND: "/api/pplan/demand/",
    VERSION: "/api/pplan/version/",
    PRODUCTION_ORDER_DEMAND: "/api/pplan/production_order_demand/",
    DAILY_PRODUCTION_PERIPHERAL: "/api/pplan/daily_production_peripheral/",
    PLANNING: "/api/pplan/worker_planning/",
    DAILY_PLANNING: "/api/pplan/daily_planning/",
    GROUP_PLANNING: "/api/pplan/group_planning/",
    SPREADSHEET_IMPORT: "/api/pplan/spreadsheet_import/",
    SPREADSHEET_IMPORT_ITEM: "/api/pplan/spreadsheet_import_item/",
    PRODUCT_STOCK: "/api/pplan/product_stock/",
    DELIVERY: "/api/pplan/delivery/",
    SIMULATION: "/api/pplan/simulation/",
    DAILY_PRODUCTION: "/api/pplan/daily_production/",

    // production_capacity
    SMT_TIME: "/api/pplan/smt_time/",
    SMT_TIME_LINE: "/api/pplan/smt_time_line/",
    SMT_DEFAULT_TIME_: "/api/pplan/smt_default_time/",
    MANUAL_DEFAULT_TIME: "/api/pplan/manual_default_time/",

    // settings
    HEADCOUNT: "/api/pplan/headcount/",
    EXPRESSION_BUILDER: "/api/pplan/expression_builder/",
    SETTING: "/api/pplan/settings/",

    // dashboard
    LINE_SCHEDULE: "/api/pplan/line_schedule/",
    LINE_SCHEDULE_MODEL: "/api/pplan/line_schedule_model/",
    LINE_SCHEDULE_STATION: "/api/pplan/line_schedule_station/",

    // npi
    TEMPLATE: "/api/npi/template/",
    NPI: "/api/npi/npi/",
    NPI_DASHBOARD_DATA: "/api/npi/dashboard/data",
    NPI_TASK: "/api/npi/npi_task/",
    NPI_PROJECT_TYPE: "/api/npi/project_type/",
    NPI_CALENDAR: "/api/npi/calendar/",
    TEMPLATE_GROUP: "/api/npi/template_group/",
    TEMPLATE_TASK: "/api/npi/template_task/",
    HOLIDAY: "/api/npi/holiday/",
};
